/**
 * 3 CTA types, mutually exclusive
 */
export enum CollectionCtaTypes {
  SIGN_UP = 'Sign Up',
  FAVORITE = 'Favorite',
  FAVORITED = 'Favorited'
}
